<template>
  <div>
    <div class="selected-spending-limit">
      <span>{{ t('new_spending_limit') }}</span>
      <strong class="value">
        $ {{ formatNumberByLocale(selectedStore?.spendingLimit?.pendingLimit ?? 0) }} US Dollars
      </strong>
    </div>
    <div class="button-wrapper">
      <gs-button @click="$emit('back')" icon="mdi-chevron-left" size="large" type="outlined">
        {{ $t('CommonUi.back') }}
      </gs-button>
      <gs-button @click="goToShopifyUrl" type="primary" size="large" full-width>
        {{ t('proceed_to_shopify') }}
      </gs-button>
    </div>
    <gs-button
      v-if="!selectedPlan && !account.userFromMarketplace"
      @click="$emit('cancel')"
      class="mt-2"
      full-width
      type="info"
      size="large"
    >
      {{ t('cancel_shopify_integration') }}
    </gs-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import { type Integration } from '@/store/integrations'
import { Utils } from '@/helpers/mixins/utilsMixin'
import type { NewPaidBusinessSubscriptionType, PersonalSubscriptionType } from '@/helpers/pricing'
import { type Account } from '@/store'

export default defineComponent({
  name: 'ConfirmCustomSpendingLimit',
  mixins: [Utils],
  emits: ['back', 'save', 'cancel'],
  computed: {
    account(): Account {
      return this.$store.getters['getAccount']
    },
  },
  methods: {
    t(key: string, params?: { [k: string]: string }) {
      return this.$t(`ShopifyCustomSpendingLimitView.${key}`, params || {})
    },
    goToShopifyUrl() {
      window.open(this.selectedStore.spendingLimit?.pendingLimitUrl, '_self')
    },
  },
  props: {
    selectedStore: {
      type: Object as PropType<Integration>,
      required: true,
    },
    selectedPlan: {
      type: String as PropType<NewPaidBusinessSubscriptionType | PersonalSubscriptionType>,
    },
  },
})
</script>

<style lang="scss" scoped>
@import '~vuetify/settings';

.selected-spending-limit {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
  padding: 8px;
  font-size: 20px;
  font-weight: bold;
  background-color: #47d18f33;

  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    justify-content: space-between;
    flex-direction: row;
  }

  .value {
    font-size: 32px;
  }
}

.button-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 32px;
}
</style>
